import FleetoraClient from "./services/fleetora";
import { CachedSnapshot, Model, Paint, Vehicle } from "./entities";

export let carrierLoader: Promise<void>;
export let paintsLoader: Promise<void>;
export let orderingsLoader: Promise<void>;
export let vehiclesLoader: Promise<void>;

export let carrier: Model[];
export let paints: Paint[];
export let vehicles: Vehicle[];
export let cachedSnapshot: CachedSnapshot;

export let fleetoraClient = new FleetoraClient();

export async function loadCarrier() {
  carrier = await fleetoraClient.getCarrier();
}

export async function loadPaints() {
  paints = await fleetoraClient.getPaints();
}

export async function loadTraffic() {
  try {
    cachedSnapshot = await fleetoraClient.getTraffic();
    vehicles = cachedSnapshot.vehicles;
  } catch (err) {
    console.error("Failed to request through Fleetora, trying SignalR", err);
    throw err;
  }
}

export async function load() {
  carrierLoader = loadCarrier();
  paintsLoader = loadPaints();
  vehiclesLoader = loadTraffic();

  await Promise.all([carrierLoader, paintsLoader, vehiclesLoader]);
}
